import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { PipelineProjectListResultModel, PipelineStatusProgressResultModel, PipelineTimelineResultModel } from '../interfaces/entities/dashboard';

const PIPELINE_CACHE_TTL_MS = 5 * 60 * 1000;

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private readonly pipelineCache = new Map<string, { data: unknown; expiresAt: number }>();

  constructor(private apiService: ApiBaseService) { }

  private async getCached<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
    const entry = this.pipelineCache.get(key);
    if (entry && Date.now() < entry.expiresAt) {
      return entry.data as T;
    }
    const data = await fetcher();
    if (!(data as any)?.hasError) {
      this.pipelineCache.set(key, { data, expiresAt: Date.now() + PIPELINE_CACHE_TTL_MS });
    }
    return data;
  }

  invalidatePipelineCache(): void {
    this.pipelineCache.clear();
  }

  async getProjekteDashboardList(payLoad: any, showLoader = true): Promise<any> {
    return this.apiService.httpRequest('DashboardService/GetProjekteDashboardList', payLoad, true, showLoader);
  }

  async getEpcList(payload: any): Promise<any> {
    return this.apiService.httpRequest('DashboardService/GetEPCList', payload, true, true);
  }

  async getPartnerList(payload: any): Promise<any> {
    return this.apiService.httpRequest('DashboardService/GetPartnerList', payload, true, false);
  }

  async GetPipelineProjectList(): Promise<PipelineProjectListResultModel> {
    return this.getCached('projectList', () =>
      this.apiService.httpRequest('DashboardService/GetPipelineProjectList', {}, false, true)
    );
  }

  async GetPipelineTimeline(): Promise<PipelineTimelineResultModel> {
    return this.getCached('timeline', () =>
      this.apiService.httpRequest('DashboardService/GetPipelineTimeline', {}, false, true)
    );
  }

  async GetPipelineStatusProgress(): Promise<PipelineStatusProgressResultModel> {
    return this.getCached('statusProgress', () =>
      this.apiService.httpRequest('DashboardService/GetPipelineStatusProgress', {}, false, true)
    );
  }
}
